import styled from '@emotion/styled';
import React from 'react';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';
import mainContext from '../../../contexts/mainContext';
import Chip from '@mui/material/Chip';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import { getAllReviewsController } from '../../../Controllers/userManagment/common';
import { __snackBarSeverity, __snackBarText } from '../../../constants';
const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN

const Reviews = (props) => {
    const { userId, reviewDetails = [], review } = props;
    const { setSnackBar, nth, months } = React.useContext(mainContext)
    const [open, setOpen] = React.useState(false);
    const [allReviews, setAllReviews] = React.useState([]);

    const getAllReviews = async () => {
        const res = await getAllReviewsController(userId);
        if (res && res.status === 500) {
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message || __snackBarText.unKnownError,
                severity: __snackBarSeverity.error
            })
        }
        setAllReviews(res.data.data.review);
    }

    return (
        <>
            <Container>
                <strong className="title">
                    Reviews
                </strong>
                {
                    reviewDetails.length > 0 ?
                        <>
                            {
                                reviewDetails.map((e, index) => {
                                    const createdAt = new Date(e.createdAt);
                                    return (
                                        <Review key={index}>
                                            <Rating name="read-only" value={e.rating} readOnly sx={{ fontSize: "95%" }} />
                                            <p>{e?.comment}</p>
                                            <div>
                                                by {e?.name || ""} <span className='title'>{`${createdAt.getDate()}${nth(createdAt.getDate())} ${months[createdAt.getMonth()]} ${createdAt.getFullYear()}`}</span>
                                            </div>
                                        </Review>
                                    )
                                })
                            }
                            {
                                review.count > 2 ?
                                    <ShowMoreBtn onClick={() => { setOpen(true); getAllReviews() }}>
                                        <Chip label="Show all" variant="outlined" />
                                    </ShowMoreBtn>
                                    :
                                    <></>
                            }
                        </>
                        :
                        <small>No reviews</small>
                }
            </Container>
            <Drawer
                anchor={anchor}
                open={open}
                onClose={() => { setOpen(!open) }}
            >
                <CanvasConatiner>
                    <Header>
                        <h4>Reviews</h4>
                        <CloseIcon className='pointer' onClick={() => { setOpen(false) }} />
                    </Header>
                    <Body>
                        {
                            allReviews.map((e, index) => {
                                const createdAt = new Date(e.createdAt);
                                return (
                                    <Review key={index}>
                                        <Rating name="read-only" value={e.rating} readOnly sx={{ fontSize: "95%" }} />
                                        <p>{e?.comment}</p>
                                        <div>
                                            by {e?.name || ""} <span className='title'>{`${createdAt.getDate()}${nth(createdAt.getDate())} ${months[createdAt.getMonth()]} ${createdAt.getFullYear()}`}</span>
                                        </div>
                                        <Divider className='divider-gap' />
                                    </Review>
                                )
                            })
                        }
                    </Body>
                </CanvasConatiner>
            </Drawer>
        </>
    )
}

const Container = styled("div")`
    height: 100%;
    min-width: 100%;
    display: grid;
    row-gap: 0.5rem;
    .title{
        color: var(--nona-theme-color);
        font-size: 90%;
    }
`;

const Review = styled("div")`
    p{
        margin-top: 0.3rem;
        font-family: "regular";
        font-size: 100%;
    }
    div{
        margin-top: 0.4rem;
        display: flex;
        align-items: center;
        column-gap: 1rem;
        font-size: 70%;
        font-family: "semi-bold";
    }
`;

const ShowMoreBtn = styled("div")`
    float: right;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
    &>div{
        cursor: pointer !important;
    }
`;

const CanvasConatiner = styled("div")`
    height: 100%;
    min-width:340px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    .divider-gap{
        margin: 0.8rem 0;
    }
`;

const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;

export default Reviews